'use client'

import { Typography, Button, Space } from 'antd'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { IconProp } from '@fortawesome/fontawesome-svg-core'

const { Title } = Typography

interface SectionTitleProps {
  icon: IconProp
  title: string
  isEditing?: boolean
  onEdit?: () => void
  onSave?: () => void
  onCancel?: () => void
  showEditButton?: boolean
  isGlobalEditMode?: boolean
}

export const SectionTitle: React.FC<SectionTitleProps> = ({
  icon,
  title,
  isEditing,
  onEdit,
  onSave,
  onCancel,
  showEditButton = true,
  isGlobalEditMode = false,
}) => (
  <div
    className={`w-full bg-stone-100 rounded-lg px-3 py-2 border-b-2 border-[#3847A4]/10 flex ${
      isEditing
        ? 'flex-col sm:flex-row items-start sm:items-center'
        : 'items-center'
    } justify-between gap-3 mb-8`}
    aria-label={title}
  >
    <div className='flex items-center gap-3'>
      <span className='bg-stone-200 p-3 rounded-full flex items-center justify-center'>
        <FontAwesomeIcon icon={icon} className='text-primary text-xl' />
      </span>
      <Title
        level={5}
        style={{ margin: 0, color: '#06686B' }}
        className='uppercase'
      >
        {title}
      </Title>
    </div>
    {showEditButton && !isGlobalEditMode && (
      <Space
        className={`${isEditing ? 'w-full sm:w-auto flex justify-end' : ''}`}
      >
        {!isEditing ? (
          <Button
            type='primary'
            icon={<FontAwesomeIcon icon='pencil' className='text-white' />}
            onClick={onEdit}
            aria-label={`Edit ${title}`}
            data-testid={`edit-${title.toLowerCase()}-button`}
          >
            Edit
          </Button>
        ) : (
          <>
            <Button
              onClick={onCancel}
              aria-label={`Cancel editing ${title}`}
              data-testid={`cancel-${title.toLowerCase()}-button`}
            >
              Cancel
            </Button>
            <Button
              type='primary'
              onClick={onSave}
              aria-label={`Save changes to ${title}`}
              data-testid={`save-${title.toLowerCase()}-button`}
            >
              Save Changes
            </Button>
          </>
        )}
      </Space>
    )}
  </div>
)

export default SectionTitle
